class RecentlyViewed extends HTMLElement {
    observer = undefined;

    constructor() {
        super();
        this.recentlyContainer = document.querySelector(this.dataset.recentlySelector);

        this.stack = JSON.parse(localStorage.getItem('viewedProducts'))?.filter(handle => handle !== this.dataset.handle) || [];
        if (this.dataset.maxItems && this.stack.length > this.dataset.maxItems) {
            this.stack = this.stack.splice(0, this.dataset.maxItems);
        }
        if (this.stack.length) {
            this.recentlyContainer?.classList.remove('tw-hidden');
        }
        this.isMobile = window.innerWidth < 1024;
    }

    connectedCallback() {
        this.initializeRecentelyViewed();
    }
    
    initializeRecentelyViewed() {
        this.observer?.unobserve(this);
        this.observer = new IntersectionObserver(
            (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);
            this.render();
            },
            { rootMargin: '0px 0px 400px 0px' }
        );
        this.observer.observe(this);
    }

    async render() {
        let request = this.getSanitazedUrl();
        const response = await fetch(request);
        const responseText = await response.text();

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const slides = html.querySelectorAll('[data-slide]');
        slides.forEach(slide => {
            this.querySelector('.swiper-wrapper').innerHTML += slide.innerHTML;
        })

    }

    getSanitazedUrl() {
        let request = '';
        for (let i = 0; i < this.stack.length; i++)
            request += '&rec_view=' + this.stack[i];

        const rootUrl = window.routes.root_url || ''
        return `${location.origin + rootUrl}/search?q=${new Date().toString()}&view=recently-viewed${request}`

    }

}

customElements.define('recentely-viewed', RecentlyViewed);